<template>
  <div>
    <ShowDetails v-if="!is_sdp_v2"/>
    <ShowDetailsV2 v-if="is_sdp_v2"/>
  </div>
</template>
<script>
import ShowDetailsV2 from './ShowDetails';
import ShowDetails from '../ShowDetails';

export default {
  name: 'ShowDetailsWrapper',
  components: {
    ShowDetailsV2,
    ShowDetails,
  },
  data() {
    return {
      is_sdp_v2: false,
    };
  },
  beforeMount() {
    this.getFeatureFlag();
  },
  methods: {
    getFeatureFlag() {
      this.is_sdp_v2 = this.$store.getters.flagWithDefault('web_v2_sdp', true);
    },
  },
};
</script>
